export const isEnableItemsPerLine = true;

export const itemKey = isEnableItemsPerLine ? "line" : "id";
